'use strict';

/**
 * AdminDashboardController - contrôleur du tableau de bord administratif
 */
import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminDashboardController', ['$scope', '$http', function($scope, $http) {
  
  // Initialiser les statistiques
  $scope.stats = {
    datasets: 0,
    organizations: 0,
    users: 0,
    visits: 0
  };
  
  // Données simulées pour les graphiques
  $scope.activityLabels = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin'];
  $scope.activityData = [[32, 45, 55, 70, 89, 120]];
  
  $scope.categoriesLabels = ['Budget', 'Pétrole', 'Mines', 'Santé', 'Éducation'];
  $scope.categoriesData = [25, 20, 15, 10, 30];
  
  // Options des graphiques
  $scope.chartOptions = {
    responsive: true,
    maintainAspectRatio: false
  };
  
  // Simuler des activités récentes pour le développement
  $scope.recentActivities = [
    {
      date: new Date(2023, 3, 25, 10, 30),
      user: 'admin',
      action: 'Création',
      details: 'Nouveau jeu de données: Budget 2023'
    },
    {
      date: new Date(2023, 3, 24, 15, 45),
      user: 'editor',
      action: 'Modification',
      details: 'Organisation: Ministère des Finances'
    },
    {
      date: new Date(2023, 3, 23, 9, 15),
      user: 'admin',
      action: 'Suppression',
      details: 'Utilisateur: test123'
    }
  ];
  
  // Charger les statistiques depuis l'API
  function loadStats() {
    $http.get('/api/admin/stats')
      .then(function(response) {
        $scope.stats = response.data;
      })
      .catch(function() {
        console.error('Erreur lors du chargement des statistiques');
        // Les valeurs par défaut sont déjà définies
      });
  }
  
  // Appel initial pour charger les statistiques
  loadStats();
}]);
